import { Inject, Injectable } from '@angular/core'
import { LocalStorage } from 'ngx-store'
import { APIService, BOOTSTRAP_DATA } from 'api/module'
import { BootstrapData } from 'elements-sdk'
import * as semver from 'semver'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { ReleaseNotesModalComponent } from '../components/releaseNotesModal.component'

@Injectable({ providedIn: 'root' })
export class ReleaseNotesService {
  @LocalStorage('currentRelease') storedCurrentRelease = ''
  @LocalStorage('lastViewedReleaseNotes') storedLastViewedReleaseNotes = ''
  @LocalStorage('previousRelease') storedPreviousRelease = ''
  @LocalStorage('lastUpgradeTime') storedLastUpgradeTime = ''

  currentRelease: string
  previousRelease: string
  lastSeenRelease: string
  lastUpgradeTime: number

  constructor (
    private api: APIService,
    private ngbModal: NgbModal,
    @Inject(BOOTSTRAP_DATA) private bootstrapData: BootstrapData,
  ) {
    const lastSeenRelease = semver.coerce(this.storedCurrentRelease || this.storedLastViewedReleaseNotes)
    this.currentRelease = semver.coerce(this.bootstrapData.version.release)?.format() ?? '0.0.0'
    this.previousRelease = semver.coerce(this.storedPreviousRelease)?.format() ?? '0.0.0'
    this.lastUpgradeTime = parseInt(this.storedLastUpgradeTime || '0')

    if (lastSeenRelease && semver.neq(this.currentRelease, lastSeenRelease)) {
      this.lastUpgradeTime = Math.floor(Date.now())
      this.storedPreviousRelease = lastSeenRelease.format()
      this.storedLastUpgradeTime = this.lastUpgradeTime.toString()
    }

    this.storedCurrentRelease = this.currentRelease.toString()
  }

  open (): void {
    const m = this.ngbModal.open(
      ReleaseNotesModalComponent,
      { windowClass: 'release-notes-modal' },
    )
    m.componentInstance.releaseNotes = this
    m.result.catch(() => null)
    this.markViewed()
  }

  featureIsNew (release: string): string|boolean {
    if (!this.hasNew()) {
      return false
    }
    return this.storedPreviousRelease && semver.lt(this.storedPreviousRelease, release)
  }

  hasNew (): boolean {
    return !this.storedLastViewedReleaseNotes || semver.neq(this.currentRelease, this.storedLastViewedReleaseNotes)
  }

  markViewed (): void {
    if (this.currentRelease) {
      this.storedLastViewedReleaseNotes = this.currentRelease.toString()
    }
  }
}

if (localStorage.getItem('ngStorage-currentRelease')) {
  for (const key of [
    'currentRelease',
    'lastViewedReleaseNotes',
    'previousRelease',
    'lastUpgradeTime',
  ]) {
    localStorage.setItem(key, localStorage.getItem('ngStorage-' + key) ?? '')
    localStorage.removeItem('ngStorage-' + key)
  }
}
